"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuyRateFormula = void 0;
exports.getBuyRate = getBuyRate;
const general_formulas_1 = require("./general-formulas");
const get = require('lodash/get');
/**
 * Enumeration of BuyRate formula implementation names
 */
var BuyRateFormula;
(function (BuyRateFormula) {
    BuyRateFormula[BuyRateFormula["DEFAULT"] = 0] = "DEFAULT";
    BuyRateFormula[BuyRateFormula["POINT_CONDITIONAL"] = 1] = "POINT_CONDITIONAL";
})(BuyRateFormula || (exports.BuyRateFormula = BuyRateFormula = {}));
/**
 * Returns the specified buyRate implementation
 */
function getBuyRate(formula) {
    switch (formula) {
        case BuyRateFormula.POINT_CONDITIONAL:
            return pointConditional_BuyRate;
        default:
            return default_BuyRate;
    }
}
///////////////////////////
// Function Implementations
///////////////////////////
const default_BuyRate = (buyRate, points) => {
    // ensure valid argument types
    if (typeof buyRate === 'number' && typeof points === 'number') {
        // default implementation is to just use the buy rate provided
        return buyRate;
    }
    return NaN;
};
const pointConditional_BuyRate = (buyRate, points, conditionalThresholdParams) => {
    if (typeof buyRate === 'number' && typeof points === 'number') {
        // Adding default threshold values here so we don't need to keep passing them.
        const conditionalParams = {
            pointConditionalBuyrateThreshold: get(conditionalThresholdParams, 'pointConditionalBuyrateThreshold', 8),
            pointConditionalBuyrateFactor: get(conditionalThresholdParams, 'pointConditionalBuyrateFactor', 1),
            pointConditionalBuyrateThreshold2: get(conditionalThresholdParams, 'pointConditionalBuyrateThreshold2', null),
            pointConditionalBuyrateFactor2: get(conditionalThresholdParams, 'pointConditionalBuyrateFactor2', 0.5),
        };
        let additionalPoints = 0;
        if (points > conditionalParams.pointConditionalBuyrateThreshold) {
            additionalPoints = (points - conditionalParams.pointConditionalBuyrateThreshold) * conditionalParams.pointConditionalBuyrateFactor;
        }
        if (conditionalParams.pointConditionalBuyrateThreshold2 != null
            && points > conditionalParams.pointConditionalBuyrateThreshold2) {
            additionalPoints += (points - conditionalParams.pointConditionalBuyrateThreshold2) * conditionalParams.pointConditionalBuyrateFactor2;
        }
        return (0, general_formulas_1.toFixedNumber)(buyRate + additionalPoints / 100, 3);
    }
    return NaN;
};
//# sourceMappingURL=buyrate-formula.js.map